<template>
  <div class="userList">
    <div class="content">
      <div class="userList-top">
        <span style="font-size:16px">操作记录</span>
        <div class="btns">
          <!-- <el-button type="primary" size="mini" @click="exportList">导入</el-button> -->
          <el-button type="primary" size="mini" @click="exportList" class="last-el-button">导出</el-button>
        </div>

      </div>
      <div class="search">
        <el-form ref="form" :model="form" label-width="92px" size="medium" style="display: flex;width: auto;">
          <el-form-item label="用户卡ID：">
            <el-input v-model="form.cardNum" placeholder="请输入用户卡ID" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="用户账号：">
            <el-input v-model="form.userCode" placeholder="请输入用户账号" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="记录类型：">
            <el-select v-model="form.recordType" clearable placeholder="请选择" class="el-input-mysmall">
              <el-option v-for="item in recordTypeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期：">
            <el-date-picker v-model="startDate" align="right" :picker-options="pickerOptions" type="datetime"
              placeholder="选择开始日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期：">
            <el-date-picker v-model="endDate" align="right" :picker-options="pickerOptions" type="datetime"
              placeholder="选择结束日期"> </el-date-picker>
          </el-form-item>
        </el-form>

        <el-button type="primary" size="mini" @click="search" plain class="search-btn">查询</el-button>
      </div>
      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table :data="tableData" stripe style="width: 100%" :max-height="heights - 20">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column prop="cardNum" label="用户卡ID" width="237"> </el-table-column>
          <el-table-column prop="userCode" label="用户账号" width="237"> </el-table-column>
          <el-table-column prop="recordType" label="记录类型" width="237"> </el-table-column>
          <el-table-column prop="recordDetails" label="记录内容" width="473"> </el-table-column>
          <el-table-column label="操作时间">
            <template #default="{row}">
              <span>{{row.createTime | date_format}}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>


  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";

  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  export default {
    components: {
      downloadTable
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: true,
        form: {},
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 15,
        tableData: [],//表格数据
        startDate: new Date().getTime()-86400000,//日期
        endDate: new Date().getTime(),//日期
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },

      };
    },

    mounted () {
      //获取角色类型
      findRecordType().then(res => {
        this.recordTypeList=res.data
      })

      this.getList() //获取列表数据

    },
    computed: {

    },
    watch: {},

    methods: {
      //搜索
      search () {
        var d={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'startTime': typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
          'endTime': typeof this.endDate=='number'? this.endDate:this.endDate.getTime(),
        }
        var obj=this.form
        for(let k in obj) {
          if(k,obj[k]=='') {
            Reflect.deleteProperty(obj,k)
          }
        }
        const result=Object.assign(obj,d)
        this.loading=true
        findOperatingRecord(result).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content
            this.total=res.data.totalElements
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败')
            this.loading=false
          }
        })
      },

      //获取列表数据
      getList () {
        var d={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'startTime': typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
          'endTime': typeof this.endDate=='number'? this.endDate:this.endDate.getTime(),
        }
        this.loading=true
        findOperatingRecord(d).then(res => {
          if(res.code==200) {
            this.total=res.data.totalElements
            this.tableData=res.data.content
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查看失败')
            this.loading=false
          }
        })
      },

      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-操作记录','.userList-table')
      },

      //分页功能
      newgetNowPageDataList () {
        // 当前页显示
        this.getList()
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }



      }

      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;

        //  left: -3px;
        /deep/.el-form-item {
          margin-bottom: 0px;
        }

        /deep/.el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 240px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        /deep/.el-table th {
          border-right: 1px solid #E6E6E6;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        margin-right: 15px;
      }

    }

    /deep/.el-form-item__label {
      padding: 0px;
    }



  }
</style>